const PAYMENT_OPTION_TITLE = {
  kakao_pay: "Kakao Pay",
  bank_transfer: "Bank transfer",
  paytm: "Paytm",
  phonepe: "Phonepe",
  upi: "UPI",
};

const PAYMENT_OPTION_CSS_CLASS = {
  paytm: "paytm",
  phonepe: "phonepe",
  upi: "upi",
  kakao_pay: "kakaopay",
  bank_transfer: "banktransfer",
};

function titleCaseSlug(slug) {
  return String(slug || "")
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function getPaymentOptionSlug(option) {
  const o = option?.option;
  if (typeof o === "string") return o;
  return o?.slug || "";
}

export function getPaymentDeepLink(option) {
  const d = option?.details;
  if (!d) return "";
  const link = d.link || d.kakao_link;
  return String(link || "").trim();
}

export function getPaymentOptionClass(option) {
  return PAYMENT_OPTION_CSS_CLASS[getPaymentOptionSlug(option)] || "other";
}

export function normalizeOrderPaymentOptions(order) {
  if (!order || !Array.isArray(order.payment_options)) {
    return order;
  }

  return {
    ...order,
    payment_options: order.payment_options.map((po) => {
      let option = po.option;

      if (typeof option === "string") {
        const slug = option;
        option = {
          slug,
          title: PAYMENT_OPTION_TITLE[slug] || titleCaseSlug(slug),
        };
      }

      const details = { ...po.details };

      if (option?.slug === "kakao_pay" && details.kakao_link && !details.link) {
        details.link = details.kakao_link;
      }

      return { ...po, option, details };
    }),
  };
}

export function normalizeMockOrderData(data) {
  const now = Date.now();

  return normalizeOrderPaymentOptions({
    ...data,
    created_at: new Date(now).toISOString(),
    expired_at: new Date(now + 10 * 60 * 1000).toISOString(),
  });
}
